import { DATA_DIR } from "../consts";
export function transformMedianameToUrl(mediaName, kind) {
    if (!mediaName) {
        return null;
    }
    var filename = mediaName.toLowerCase();
    if (filename.startsWith("http://") || filename.startsWith("https://")) {
        // No transformation for absolute urls
        return mediaName;
    }
    var extensionKind = {
        img: ".jpg",
        track: ".mp3",
        sound: ".mp3",
    }[kind];
    var folderKind = {
        img: "img",
        track: "track",
        sound: "sound",
    }[kind];
    var extension = !filename.endsWith(extensionKind) ? extensionKind : "";
    return DATA_DIR + folderKind + "/" + filename + extension;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNmb3JtTWVkaWFOYW1lVG9VcmwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0cmFuc2Zvcm1NZWRpYU5hbWVUb1VybC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBRXJDLE1BQU0sVUFBVSx1QkFBdUIsQ0FDckMsU0FBd0IsRUFDeEIsSUFBK0I7SUFFL0IsSUFBSSxDQUFDLFNBQVMsRUFBRTtRQUNkLE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFFRCxJQUFNLFFBQVEsR0FBRyxTQUFTLENBQUMsV0FBVyxFQUFFLENBQUM7SUFDekMsSUFBSSxRQUFRLENBQUMsVUFBVSxDQUFDLFNBQVMsQ0FBQyxJQUFJLFFBQVEsQ0FBQyxVQUFVLENBQUMsVUFBVSxDQUFDLEVBQUU7UUFDckUsc0NBQXNDO1FBQ3RDLE9BQU8sU0FBUyxDQUFDO0tBQ2xCO0lBQ0QsSUFBTSxhQUFhLEdBQUc7UUFDcEIsR0FBRyxFQUFFLE1BQU07UUFDWCxLQUFLLEVBQUUsTUFBTTtRQUNiLEtBQUssRUFBRSxNQUFNO0tBQ2QsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUVSLElBQU0sVUFBVSxHQUFHO1FBQ2pCLEdBQUcsRUFBRSxLQUFLO1FBQ1YsS0FBSyxFQUFFLE9BQU87UUFDZCxLQUFLLEVBQUUsT0FBTztLQUNmLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDUixJQUFNLFNBQVMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQyxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO0lBQ3pFLE9BQU8sUUFBUSxHQUFHLFVBQVUsR0FBRyxHQUFHLEdBQUcsUUFBUSxHQUFHLFNBQVMsQ0FBQztBQUM1RCxDQUFDIn0=